<template>
    <section class="wallet-withdraw-info-modal">
        <h2 class="wallet-withdraw-info-modal__title">{{ $t('withdrawWarningInfo.title') }}</h2>
        <p class="wallet-withdraw-info-modal__alert-info">
            <translation-string :translation="$t('withdrawWarningInfo.fanTokenWithdraw')" />
        </p>
        <div class="wallet-withdraw-info-modal__actions-wrapper">
            <div class="button"
                @click="resetModal()"
            >
                {{ $t('withdrawWarningInfo.buttonText') }}
            </div>
        </div>
    </section>
</template>

<script>
import {
    mapActions,
} from 'vuex';

import localEpicTypes from '@webapp/store/types.js';
import translationString from '@webapp/components/translation-string.vue';

export default {
    name: 'withdraw-fan-tokens-warning-modal',
    components: {
        translationString,
    },
    methods: {
        ...mapActions({
            resetModal: localEpicTypes.RESET_MODAL,
        }),

    },
};
</script>

<style lang="scss" scoped>
.wallet-withdraw-info-modal {
    text-align: center;
    max-width: 700px;
    display: flex;
    flex-direction: column;
    align-items: center;

    &__title {
        margin: 0;
        font-size: 25px;
        color: $torch-red-color;
    }

    &__alert-info {
        font-size: 16px;
        font-weight: 600;
        color: $torch-red-color;
        max-width: 400px;
    }

    &__actions-wrapper {
        @include max-width(sm) {
            position: fixed;
            bottom: 0;
            padding: 15px;
            background: #fff;
            width: 100%;
            border: 1px solid $mercury-color;
            box-shadow: 0 -5px 20px 0 rgba(0, 0, 0, 0.1);
        }
    }
}

.button {
    text-align: center;
    width: 150px;
    margin: 0 auto;
    padding: 10px 0;
    border-radius: 4px;
    color: #fff;
    background: $torch-red-color;
}
</style>